import { unpad } from "./lines.ts";

type TemplateValue = bigint | number | string;

export function multiline(
  strings: TemplateStringsArray,
  ...values: readonly TemplateValue[]
): string {
  let result = strings[0] ?? "";

  for (let i = 0; i < values.length; i++) {
    const lastLineIndex = result.lastIndexOf("\n");
    const indent = lastLineIndex === -1 ? "" : result.slice(lastLineIndex + 1);
    result += String(values[i]).replaceAll("\n", `\n${indent}`);
    result += strings[i + 1] ?? "";
  }

  return unpad(result);
}

export function singleline(
  strings: TemplateStringsArray,
  ...values: readonly TemplateValue[]
): string {
  let result = strings[0] ?? "";

  for (let i = 0; i < values.length; i++) {
    result += String(values[i]);
    result += strings[i + 1] ?? "";
  }

  return result.replaceAll(/\s+/gu, " ").trim();
}
